exports.list = {
    path: '/hutang_dagang',
    name: 'hutang_dagang', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/hutang_dagang/List.vue"),
}
exports.show = {
    path: '/hutang_dagang/show/:no_kk',
    name: 'hutang_dagang_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/hutang_dagang/Show.vue"),
}